import { useEffect, useState } from 'react';
import Header from '@/components/Header';
import Login from '@/components/Login';
import { useNavigate } from 'react-router-dom';
import { routes } from '@/constants/routes';
import LargeContainer from '@/components/front-office/containers/LargeContainer';
const LoginPage = () => {
	const [errors, setErrors] = useState(null);
	const role = JSON.parse(localStorage.getItem('role'));
	const navigate = useNavigate();

	useEffect(() => {
		if (role && ['admin', 'super-admin', 'user'].includes(role)) {
			navigate('/back-office');
		}
	}, []);

	return (
		<LargeContainer withImage={true}>
			<Header
				heading="Connectez-vous à votre compte"
				paragraph="Vous n'avez pas encore de compte ?"
				linkName="Inscription"
				linkUrl={routes.registration}
				useLogo={false}
			/>

			{errors && (
				<ul>
					{Object.entries(errors).map((error, index) => {
						return (
							<li key={index} className="text-red-500 text-sm">
								{error[1]}
							</li>
						);
					})}
				</ul>
			)}

			<Login errors={errors} setErrors={setErrors} />
		</LargeContainer>
	);
};

export default LoginPage;
